var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10C6.32608 10 7.59785 9.47322 8.53553 8.53553C9.47322 7.59785 10 6.32608 10 5C10 3.67392 9.47322 2.40215 8.53553 1.46447C7.59785 0.526784 6.32608 0 5 0C3.67392 0 2.40215 0.526784 1.46447 1.46447C0.526784 2.40215 0 3.67392 0 5C0 6.32608 0.526784 7.59785 1.46447 8.53553C2.40215 9.47322 3.67392 10 5 10ZM7.31687 4.19187C7.43072 4.074 7.49372 3.91612 7.4923 3.75225C7.49087 3.58838 7.42514 3.43162 7.30926 3.31574C7.19338 3.19986 7.03662 3.13413 6.87275 3.1327C6.70888 3.13128 6.551 3.19428 6.43313 3.30813L4.375 5.36625L3.56687 4.55813C3.449 4.44428 3.29112 4.38128 3.12725 4.3827C2.96338 4.38413 2.80662 4.44986 2.69074 4.56574C2.57486 4.68162 2.50913 4.83838 2.5077 5.00225C2.50628 5.16612 2.56928 5.324 2.68313 5.44187L3.93313 6.69188C4.05033 6.80904 4.20927 6.87487 4.375 6.87487C4.54073 6.87487 4.69967 6.80904 4.81687 6.69188L7.31687 4.19187Z",
    fill: "#E3007F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.97b3901449fc51f0c69e6badb01f404c.svg";
export { ForwardRef as ReactComponent };